module.exports = __webpack_public_path__ + "img/46_11.488dbb6b.png";